export default __webpack_public_path__ + "static/media/history-icon.27055087.webp";